import { COMPANY } from "@/lib/constants";
import Reveal from "@/components/Reveal";

export default function About() {
  return (
    <div className="pt-28 pb-24 bg-brand-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <Reveal>
          <div className="text-center mb-14">
            <div className="divider-gold">About Us</div>
            <h1 className="mt-4 font-serif text-5xl lg:text-6xl text-brand-navy">India's trusted name in property</h1>
            <p className="mt-4 max-w-3xl mx-auto text-brand-charcoal/70">Wilshire Buildcon Co. is a Pan India real estate company specialising in acquisition, commercial & industrial deals, warehousing, office & residential spaces, and investment consulting.</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 bg-brand-gold/10 -z-10" />
              <img src={COMPANY.mdPhoto} alt={COMPANY.mdName} className="w-full aspect-[4/5] object-cover object-top" />
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div>
              <div className="divider-gold">Founder & MD</div>
              <h2 className="mt-4 font-serif text-4xl text-brand-navy">{COMPANY.mdName}</h2>
              <div className="text-sm tracking-widest uppercase text-brand-gold">{COMPANY.mdTitle}</div>
              <p className="mt-5 text-brand-charcoal/80 leading-relaxed">
                Mr. B. S. Rajput is the Founder & Managing Director of Wilshire Buildcon Co., leading the organisation with a vision to create one of India's most trusted property consulting and development companies.
              </p>
              <p className="mt-3 text-brand-charcoal/80 leading-relaxed">
                With a strong commitment to transparency, professionalism and long-term client relationships, he has helped establish Wilshire Buildcon as a reliable partner for property owners, investors, businesses and developers across India.
              </p>
              <p className="mt-3 text-brand-charcoal/80 leading-relaxed">
                Under his leadership, the company focuses on delivering verified opportunities, ethical transactions, professional guidance and end-to-end property solutions across residential, commercial and industrial sectors.
              </p>
            </div>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { t: "Our Vision", d: "To be India's most trusted real estate brand — built on transparency, verified deals and lifelong client relationships." },
            { t: "Our Mission", d: "Deliver ethical, end-to-end property solutions across residential, commercial and industrial segments." },
            { t: "Our Promise", d: "Every property verified. Every deal transparent. Every client treated as family." },
          ].map((x, i) => (
            <Reveal key={x.t} delay={i * 100}>
              <div className="bg-white border border-brand-gold/20 p-8 h-full">
                <div className="divider-gold text-xs">{`0${i + 1}`}</div>
                <h3 className="mt-3 font-serif text-2xl text-brand-navy">{x.t}</h3>
                <p className="mt-3 text-sm text-brand-charcoal/70 leading-relaxed">{x.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
